import type { Board } from 'common/api/endpoints/boards';
import type { StrippedUser } from 'common/api/endpoints/users';
import type { PostAction, PostDraftAction } from 'common/api/resources/autopilotActions';
import type { PostDraft } from 'common/api/resources/postDrafts';
import type { Post } from 'common/api/resources/posts';
import type { SyncIntegrationNames } from 'common/constants/autopilotIntegrations';

export enum QueueItemType {
  post = 'post',
  draft = 'draft',
}

type WithAuthor<T> = T & { author: StrippedUser };

export type QueuePost = Post & {
  type: QueueItemType.post;
  source: 'canny';
};

export type QueuePostDraft = PostDraft & {
  type: QueueItemType.draft;
  source: SyncIntegrationNames;
  link: string | null;
};

export type QueueItem = WithAuthor<QueuePost | QueuePostDraft>;

export type PostActionItem = PostAction & {
  board?: Board;
  duplicatePost: WithAuthor<Post>;
  source: 'canny';
  sourcePost: WithAuthor<Post>;
  urlName: string;
};

type PostDraftCommon = PostDraftAction & {
  board?: Board;
  source: SyncIntegrationNames;
  sourcePostDraft: WithAuthor<PostDraft>;
  link: string | null;
};

type PostDraftMergeActionItem = PostDraftCommon & {
  duplicatePost: WithAuthor<Post>;
};

type PostDraftCreateActionItem = PostDraftCommon & {
  duplicatePost: null;
};

export type PostDraftActionItem = PostDraftMergeActionItem | PostDraftCreateActionItem;

export type ActionItem = PostActionItem | PostDraftMergeActionItem | PostDraftCreateActionItem;
